import { ItemCardDefault } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardDefault/ItemCardDefault";
import { ItemCardLocalCombination } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardLocalCombination/ItemCardLocalCombination";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { Item } from "@coworker/apprestructured/src/shared/types/item";

export interface SearchResultsListViewItemChildrenProps {
  item: Item;
  itemStock: ItemStockInfo | undefined;
  isLocalCombination: boolean;
}

export const SearchResultsListViewItemChildren = ({
  item,
  itemStock,
  isLocalCombination,
}: SearchResultsListViewItemChildrenProps) => (
  <>
    {isLocalCombination && <ItemCardLocalCombination item={item} />}
    {!isLocalCombination && (
      <ItemCardDefault
        item={item as Item}
        itemStock={itemStock}
        disableItemStockQuery
      />
    )}
  </>
);
